import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getClients } from '../../../api/shipping/get-clients'
import { getCustomers } from '../../../api/shipping/get-customers'

const initialState = {
  isFetchingClients: false,
  clients: [],
  fetchClientsError: null,
  isFetchingCustomers: false,
  customers: [],
  fetchCustomersError: null,
}

/* Handler for making service call to fetch clients */
export const fetchCustomers = createAsyncThunk(
  'staticData/fetchCustomers',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getCustomers()
      return response.data?.data?.customerList
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

/* Handler for making service call to fetch clients */
export const fetchClients = createAsyncThunk(
  'staticData/fetchClients',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getClients()
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const staticDataSlice = createSlice({
  name: 'staticData',
  initialState,
  reducers: {
    resetClients(state) {
      state.clients = []
    },
    resetFetchClientsError(state) {
      state.fetchClientsError = null
    },
    resetFetchCustomersError(state) {
      state.fetchCustomersError = null
    },
  },
  extraReducers: (builder) => {
    /* Action which gets triggered
       when running persistor.purge() */
    builder
      .addCase(fetchClients.pending, (state) => {
        state.isFetchingClients = true
        state.clients = []
        state.fetchClientsError = null
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.isFetchingClients = false
        state.clients = action.payload
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.isFetchingClients = false
        state.fetchClientsError = action.payload
      })
      .addCase(fetchCustomers.pending, (state) => {
        state.isFetchingCustomers = true
        state.clients = []
        state.fetchCustomersError = null
      })
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        state.isFetchingCustomers = false
        state.customers = action.payload
      })
      .addCase(fetchCustomers.rejected, (state, action) => {
        state.isFetchingCustomers = false
        state.fetchCustomersError = action.payload
      })
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { resetClients, resetFetchClientsError, resetFetchCustomersError } =
  staticDataSlice.actions

export default staticDataSlice.reducer
